import React, { PureComponent } from 'react';
import Typed from 'typed.js';

export default class Typer extends PureComponent {
  static defaultProps = {
    typeSpeed: 65,
    startDelay: 500,
    showsCursor: false,
    onTypingComplete: () => {},
  };

  componentDidMount() {
    const options = {
      strings: [this.props.text],
      typeSpeed: this.props.typeSpeed,
      startDelay: this.props.startDelay,
      showCursor: this.props.showsCursor,
      onComplete: this.props.onTypingComplete,
    };
    this.typed = new Typed(this.element, options);
  }

  componentWillUnmount() {
    if (this.typed) {
      this.typed.destroy();
    }
  }

  render() {
    return (
      <span
        ref={(element) => {
          this.element = element;
        }}
      />
    );
  }
}
